import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DataPreloaderService } from './core/services/data-preloader.service';
import { UserRestrictionsService } from './core/services/user/user-restrictions.service';
import { FullAccountLockComponent } from './core/shared/components/full-account-lock/full-account-lock.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    RouterOutlet,
    FullAccountLockComponent,
  ],
})
export class AppComponent {

  public loader = inject(DataPreloaderService);
  public restrictions = inject(UserRestrictionsService);

}
